import React, { useState, useEffect } from 'react';

const NumberCaptcha = ({ onCaptchaChange,reset}) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [userAnswer, setUserAnswer] = useState('');

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (reset) {
      clearInput();
    }
  }, [reset]);


  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setQuestion(`${num1} + ${num2}`);
    setAnswer(num1 + num2);
  };

  const handleChange = (e) => {
    setUserAnswer(e.target.value);
    onCaptchaChange(e.target.value === String(answer));
  };

  const clearInput = () => {
    generateCaptcha();
    setUserAnswer('');  // Clear the input field
    onCaptchaChange(false);  // Reset CAPTCHA validity
  };

  return (
    <div style={{marginTop:"20px"}}>
      <label>
        Solve: {question}
        <input
        style={{backgroundColor:"#E1AFD1" , marginLeft:"10px", padding:"10px"}}
          type="number"
          value={userAnswer}
          onChange={handleChange}
          required
        />
      </label>
    </div>
  );
};

export default NumberCaptcha;
